import React from 'react';
import { History } from 'lucide-react';

interface HistoryButtonProps {
  onClick: () => void;
  className?: string;
}

export default function HistoryButton({ onClick, className = '' }: HistoryButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`p-1 text-gray-400 hover:text-gray-600 transition-colors ${className}`}
      title="Vezi istoric modificări"
    >
      <History className="w-4 h-4" />
    </button>
  );
}